import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import IPersonModalProps from "./IPersonModalProps";
import IPerson from "../../models/people/IPerson";
import Status from "../../enums/Status";
import peopleService from "../../services/peopleService";
import { Avatar } from "../../components/avatar/Avatar";

export const PersonModal = (props: IPersonModalProps) => {
    const { t } = useTranslation();
    const { show, personId, onDismiss } = props;

    const [status, setStatus] = useState<Status>(Status.NEUTRAL);
    const [person, setPerson] = useState<IPerson>(null!);

    useEffect(() => {
        getPerson(personId, setPerson, setStatus);
    }, [personId]);

    const getPhotoUrl = () => `${process.env.REACT_APP_API_BASE_URL}people/${person.id}/photo`;

    return (
        <Modal centered show={show}>
            <Modal.Header className="border-bottom-0">
                {
                    [Status.NEUTRAL || Status.LOADING].includes(status) &&
                    <Modal.Title>{t("general.loading")}</Modal.Title>
                }
                {
                    status === Status.LOAD_SUCCESS &&
                    <Modal.Title>{person.name}</Modal.Title>
                }
            </Modal.Header>

            <Modal.Body>
                {
                    [Status.NEUTRAL || Status.LOADING].includes(status) &&
                    <div className="text-center">
                        <Spinner />
                        <span className="d-block sfw-bold">{t("people.loading.single")}</span>
                    </div>
                }
                {
                    status === Status.LOAD_ERROR &&
                    <Alert variant="danger">{t("people.errors.loadPerson")}</Alert>
                }
                {
                    status === Status.LOAD_SUCCESS &&
                    <div>
                        <div className="w-100 mb-4 text-center">
                            <Avatar src={getPhotoUrl()} name={person.name} alt={person.name} size="lg" />
                        </div>
                        
                        <ul>
                            <li dangerouslySetInnerHTML={{ __html: t("people.detail.position", { position: person.position }) }} />
                            <li dangerouslySetInnerHTML={{ __html: t("people.detail.team", { team: person.team }) }} />
                            <li dangerouslySetInnerHTML={{ __html: t("people.detail.department", { department: person.department }) }} />
                            <li dangerouslySetInnerHTML={{ __html: t("people.detail.country", { country: person.country }) }} />
                            <li dangerouslySetInnerHTML={{ __html: t("people.detail.region", { region: person.region }) }} />
                            <li dangerouslySetInnerHTML={{ __html: t("people.detail.email", { email: person.email }) }} />
                            {
                                person.mobilePhone &&
                                <li dangerouslySetInnerHTML={{ __html: t("people.detail.mobile", { mobile: person.mobilePhone }) }} />
                            }
                            {
                                person.telephone &&
                                <li dangerouslySetInnerHTML={{ __html: t("people.detail.tel", { tel: person.telephone }) }} />
                            }
                        </ul>
                    </div>
                }
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onDismiss}>
                    {t("general.close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

async function getPerson(
    personId: string,
    setPerson: (person: IPerson) => void,
    setStatus: (status: Status) => void
) {
    setStatus(Status.LOADING);

    try {
        const person = await peopleService.getPerson(personId);
        setPerson(person);

        setStatus(Status.LOAD_SUCCESS);
    } catch {
        setStatus(Status.LOAD_ERROR);
    }
}